const initialState = {
    data: {},
    submitted: false,
    message: undefined,
    form: {}
};

function performancesReducer(state = initialState, action = {}) {
    switch (action.type) {
        case 'KPI_VIEW_REQUEST':
            return {
                ...state,
                user: action.user,
                submitted: true
            };
        case 'KPI_VIEW_SUCCESS':
            return {
                ...initialState,
                success: true
            };

        case 'KPI_VIEW_API_ERROR':
            return {
                ...state,
                submitted: false,
                message: action.message,
                form: action.form
            };

        case 'KPI_THRESOLD_MODIDY_REQUEST':
            return {
                ...state,
                user: action.user,
                submitted: true
            };

        case 'KPI_THRESOLD_MODIDY_SUCCESS':
            return {
                ...initialState,
                data: action.data
            };

        case 'KPI_THRESOLD_MODIDY_API_ERROR':
            return {
                ...state,
                submitted: false,
                message: action.message,
                form: action.form
            };

        case 'THRESOLD_DEFAULT_REQUEST':
            return {
                ...state,
                user: action.user,
                submitted: true
            };

        case 'THRESOLD_DEFAULT_SUCCESS':
            return {
                ...initialState,
                data: action.data
            };

        case 'THRESOLD_DEFAULT_API_ERROR':
            return {
                ...state,
                submitted: false,
                message: action.message,
                form: action.form
            };

        case 'INVENTORY_VIEW_REQUEST':
            return {
                ...state,
                user: action.user,
                submitted: true
            };

        case 'INVENTORY_VIEW_SUCCESS':
            return {
                ...initialState,
                enterpriseName: action.enterpriseName,
                ecpdId: action.ecpdId,
                nibId: action.nibId,
                solutionType:action.solutionType,
                networks: action.networks,
                updatedDate: action.updatedDate
            };

        case 'IBWAVE_VIEW_SUCCESS':
            return {
                ...initialState,
                enterpriseName: action.buildings,
                ecpdId: action.ecpdId,
                updatedDate: action.updatedDate
            };
        case 'IBWAVE_FLOOR_PLAN_IMAGE_SUCCESS':
            return {
                ...initialState,
                floorPlanImage: action.floorPlanImage
            };

        case 'INVENTORY_VIEW_API_ERROR':
        case 'IBWAVE_VIEW_API_ERROR':
        case 'IBWAVE_FLOOR_PLAN_IMAGE_ERROR':
            return {
                ...state,
                submitted: false,
                message: action.message,
                form: action.form
            };

        case 'FLOOR_PLAN_VIEW_REQUEST':
            return {
                ...state,
                user: action.user,
                submitted: true
            };

        case 'FLOOR_PLAN_VIEW_SUCCESS':
            return {
                ...initialState,
                enterpriseName: action.enterpriseName,
                ecpdId: action.ecpdId,
                nibId: action.nibId,
                networks: action.networks,
                updatedDate: action.updatedDate
            };

        case 'FLOOR_PLAN_VIEW_API_ERROR':
            return {
                ...state,
                submitted: false,
                message: action.message,
                form: action.form
            };

        case 'STOP_BLINK_MAP_COMPONENT':
            return {
                ...state,
                stopBlink: action.blink
            };
        case 'KPI_USAGE_REQUEST':
             return {
                 ...state,
                 user: action.user,
                 submitted: true
             };
        case 'KPI_USAGE_VIEW_API_SUCCESS':
             return {
                  ...initialState,
                  success: true
             };

        case 'KPI_USAGE_VIEW_API_ERROR':
             return {
                    ...state,
                    submitted: false,
                    message: action.message,
                   form: action.form
            };
        default:
            return state;
    }
}

export default performancesReducer;
